import {useEffect} from 'react';

import {recordRumAction} from '../../util/datadog/datadogRum';

export type CappedPanelInputs = {
  /** System metrics are capped and the panel waits for an opt-in. */
  isDelayed: boolean;
  panelId: string;
  setAllowUncappedMetrics: (allowUncappedMetrics: boolean) => void;
  /** Sent with the RUM actions. */
  title: string;
};

type CappedPanelOptIn = {
  delayed: boolean;
  /** The user clicked Load anyway on the Delay Render warning. */
  onLoadAnyway: () => void;
};

/**
 * Drives the Delay Render opt-in for panels with capped system metrics.
 * Records `system_metrics_capped_panel_mounted` while the panel is delayed, and
 * `system_metrics_capped_panel_displayed` before opting in to uncapped metrics.
 * Both events are described in observability/README.md.
 */
export function useCappedPanelOptIn({
  isDelayed,
  panelId,
  setAllowUncappedMetrics,
  title,
}: CappedPanelInputs): CappedPanelOptIn {
  useEffect(
    function reportCappedPanelShown() {
      if (isDelayed) {
        recordRumAction('system_metrics_capped_panel_mounted', {
          title,
          panelId,
        });
      }
    },
    [isDelayed, title, panelId]
  );

  function loadUncappedMetrics() {
    recordRumAction('system_metrics_capped_panel_displayed', {title, panelId});
    setAllowUncappedMetrics(true);
  }

  return {delayed: isDelayed, onLoadAnyway: loadUncappedMetrics};
}
